module.exports = __webpack_public_path__ + "static/img/hjk_gif.aa59f2b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20240117/hjk_gif.gif
// module id = XEac
// module chunks = 0